import React from 'react';
import { IndexRoute } from '@reverbdotcom/commons/dist/route_settings';

export const INDEX_PATH = '/';

export default (
  <IndexRoute
    key={INDEX_PATH}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../components/discovery/homepage').default);
        },
        'homepage',
      );
    }}
  />
);
